import { Injectable }     from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable }     from 'rxjs/Observable';
import { Subject }        from 'rxjs/Subject';
import { CompanyService } from '../company.service'
import   axios            from 'axios';
import { USER_ROLES,
         API_BASE_URL,
         ENDPOINTS }      from '../app.config';
import   Utils            from '../app.utilities';

const    utilities = new Utils();

// Types
import { UserInfo }       from './types/user-info';


@Injectable()
export class UserInfoService {
  userRole             : string;
  companyName          : string;
  businesOwnerName     : string;
  userInfo_Subject     : Subject<UserInfo> = new Subject();
  private $userInfo    : Observable<UserInfo>;
  companyId            : any;

  constructor
  (
    private activatedRoute : ActivatedRoute
  )
    {
      this.userInfo_Subject.asObservable();
    }


  /*
  The purpose is to receive the informations:
    1) userRole                : string;
    2) companyName             : string;
    3) businesOwnerName        : string;
  */
  getInformations() : Observable<UserInfo>{
    let _self = this;

    axios.get(ENDPOINTS.GET_CURRENT_USER).then(
      response => {
        _self.userRole = utilities.getUserRole(response.data);

          if ( !utilities.userAnyOfRoles(['ADMINISTRATOR', 'BUSINESS_OWNER', 'COMPANY_ADMIN'], _self.userRole ) ) {

            let userData = response.data;

            if(userData.company_editor.length){
              _self.companyName      = userData.company_editor[0].name;
              _self.businesOwnerName = userData.business_owner_name;
            }
            else if(userData.company_viewer.length){
              _self.companyName = userData.company_viewer[0].name;
              _self.businesOwnerName = userData.business_owner_name;
            }

            let userInfo = {
              userRole          : _self.userRole,
              companyName       : _self.companyName,
              businesOwnerName  : _self.businesOwnerName
            }

            // Adjust breadcrump: Companies link for BUSINESS_OWNER
            if( localStorage["businessOwnerId"] ){
              $("app-sidebar a[href*='companies']").attr("href", "companies/" + localStorage["businessOwnerId"] );
            }


            this.userInfo_Subject.next(userInfo);
          }
          /*
          For USER_ROLES: ADMINISTRATOR, BUSINESS_OWNER and COMPANY_ADMIN
            make another API call in order to receive the companyName and businesOwnerName
          */
          else {
            _self.activatedRoute.params.subscribe( params => {

              let endpoint, isCompanyEndpoint, isBusinessOwnerEndpoint;
              if (params.companyId){
                endpoint          = "/" + params.companyId;
                isCompanyEndpoint = true;
              } else {
               endpoint           = "?business_owner_id=" + params.companyOwnerId;
             }

              axios
              .get(ENDPOINTS.GET_COMPANIES + endpoint)
              .then(response => {

                if(isCompanyEndpoint){
                  _self.companyName      = response.data.name;
                  _self.businesOwnerName = response.data.business_owner.first_name;
                } else {
                  _self.companyName      = null; // /companies/id? - Where companies are selected
                  _self.businesOwnerName = response.data.length && response.data[0].business_owner.first_name;
                }


                let userInfo = {
                  userRole          : _self.userRole,
                  companyName       : _self.companyName,
                  businesOwnerName  : _self.businesOwnerName
                }


                this.userInfo_Subject.next(userInfo);
              });

            });

          } // else
      },
      error => {},
    );

    return this.userInfo_Subject;
  }

}



// WEBPACK FOOTER //
// /Users/mihagresak/Documents/git-projects/vintegras-angular-new-clean/src/app/shared/user-info.service.ts